export enum TabKey {
  Spot = '1',
  Community = '2',
  User = '3',
  Hashtag = '4',
  Comment = '5'
}

export enum GoogleMapLevel {
  DefaultZoomLevel = 12,
  MaxZoomLevel = 21,
  MinZoomLevel = 3,
  SearchZoomLevel = 5
}

export interface IHistoryListItem {
  uid: string
  count: number
  title: string
  community_id: string
  name: string
  head_shot: {
    small_headshot_url: string
  }

  user_id: string
  value: string
}

export interface ISearchUserV2 {
  type: 'user'
  id: string // user_id
  uid: string // uid
  name: string // name
  image: string // head_shot_url
}

export interface ISearchCommunityV2 {
  type: 'community'
  id: string // id
  title: string // title
  count: number // joined_count
  image: string // community_cover
}

export interface ISearchKeywordV2 {
  type: 'keyword'
  id: string // keyword
  keyword: string // keyword
}

export type ISearchHistoryV2 =
  | ISearchUserV2
  | ISearchCommunityV2
  | ISearchKeywordV2

export type searchExploreReq = {
  user_id: string
  user_coordinate: {
    lat: string
    lng: string
  }
  language: string
  size: number
}
